'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _Promise = require('@babel/runtime-corejs3/core-js-stable/promise');
var axios = require('axios');
var axios_min = require('./axios.min.js');
var httpError = require('../error/http-error.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _Promise__default = /*#__PURE__*/_interopDefaultLegacy(_Promise);

var config = {
  // TODO will change here config
};
var axiosInstance = axios_min.create(config);
axiosInstance.defaults.withCredentials = true;
if (sessionStorage.getItem('BASEURL')) {
  axiosInstance.defaults.baseURL = sessionStorage.getItem('BASEURL');
}
axiosInstance.interceptors.response.use(function (response) {
  var _response$data;
  if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.error) {
    throw new Error(response.data.message || 'Some errors have occurred.');
  }
  return response;
}, function (err) {
  var _err$response;
  if ((err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401) {
    var _context;
    if (httpError.isPasswordExpired(err.response)) {
      httpError.handlePasswordExpired();
    } else if (httpError.isSessionRevoked(err.response)) {
      httpError.showSessionEndDialog();
    } else if (!_includesInstanceProperty__default["default"](_context = window.location.hash).call(_context, 'login')) {
      var _context2;
      // don't do this when imported by cloud portal
      window.location.href = _concatInstanceProperty__default["default"](_context2 = "".concat(window.location.origin, "/#/login?returnURL=")).call(_context2, encodeURIComponent(window.location.pathname + window.location.search + window.location.hash));
    }
  }
  if (axios.isAxiosError(err)) {
    var _err$response$data;
    var message = ((_err$response$data = err.response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || err.message;
    err.error = message;
    err.message = message;
  }
  return _Promise__default["default"].reject(err);
});
var getAxiosInstance = function getAxiosInstance() {
  return axiosInstance;
};

exports.getAxiosInstance = getAxiosInstance;
